import { render, staticRenderFns } from "./Montaje.vue?vue&type=template&id=782eec82&scoped=true"
import script from "./Montaje.vue?vue&type=script&lang=js"
export * from "./Montaje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782eec82",
  null
  
)

export default component.exports